import { useNavigate, useLocation } from 'react-router-dom'

import { ApprovalStatus } from '../../services/Types'
import { useEffect } from 'react'

export type ProtectedRouteProps = {
  outlet: JSX.Element
}

export function ProtectedRoute({ outlet }: ProtectedRouteProps): any {
  const navigate = useNavigate()
  const location = useLocation()

  let user: any = localStorage.getItem('user')

  useEffect(() => {
    if (user === 'null' || user === null || user === undefined) {
      let initialRoutePath = '/'
      if (location.pathname.replace('/', '') !== '') {
        initialRoutePath = location.pathname.replace('/', '')
      }
      navigate('/', { state: { showLogin: true, initialRoute: initialRoutePath } })
    } else if (
      JSON.parse(user).role === 'REQUESTER' &&
      (location.pathname.startsWith('/admin'))
    ) {
      navigate('/')
    }
  }, [user, location.pathname, navigate])

  return outlet
}
